<template>
  <v-app>
    <v-app-bar
      app
      color="white"
      height="100"
    >
      <v-avatar
        class="mr-3"
        color="grey lighten-5"
        size="70"
      >
        <v-img
          contain
          max-height="70%"
          src="./assets/litoc_logo.png"
        ></v-img>
      </v-avatar>

      <v-toolbar-title class="font-weight-black headline">
        LITOC
      </v-toolbar-title>
    </v-app-bar>

    <v-main>
      <section id="hero">
        <v-row no-gutters>
          <v-img
            :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
            src="./assets/main_4.jpg"
          >
            <v-theme-provider dark>
              <v-container fill-height>
                <v-row
                  align="center"
                  class="white--text mx-auto"
                  justify="center"
                  style="background-color: black; opacity: 0.8;"
                >
                  <v-col
                    class="white--text text-center"
                    cols="12"
                    tag="h1"
                  >
                    <span
                    :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']"
                      class="font-weight-light"
                    >
                      WELCOME TO
                    </span>

                    <br>

                    <span
                      :class="[$vuetify.breakpoint.smAndDown ? 'display-3': 'display-4']"
                      class="font-weight-black"
                    >
                      LITOC
                    </span>

                  </v-col>

                  <v-btn
                    class="align-self-end"
                    fab
                    outlined
                    @click="$vuetify.goTo('#won-history')"
                  >
                    <v-icon>mdi-chevron-double-down</v-icon>
                  </v-btn>
                </v-row>
              </v-container>
            </v-theme-provider>
          </v-img>
        </v-row>
      </section>
      <section
        id="won-history"
      >
        <br>
        <br>
        <br>
        <h2 class="display-2 font-weight-bold mb-3 text-center" style="color:lightblue;">원유철의 한능검 N제</h2>
        <br>
        <br>
        <br>
        <v-sheet
          class="mx-auto"
        >
          <v-slide-group
            class="pa-4"
          >
            <v-slide-item
              v-for="(model, n) in models"
              :key="n"
              class="align-self-center"
              v-slot="{ active, toggle }"
            >
              <v-card
                :color="active ? 'accent' : 'white lighten-1'"
                class="ma-4 py-auto my-auto"
                height="650"
                width="300"
                @click="toggle"
              >
                <v-img
                  :src="model.src"
                  contain
                />
              </v-card>
            </v-slide-item>
          </v-slide-group>
      </v-sheet>
      </section>

      <section id="about-me">
        <div class="py-12"></div>

        <v-container>
          <h2 class="display-2 font-weight-bold mb-3 text-center">LITOC 개인정보처리방침</h2>

          <v-responsive
            class="mx-auto mb-8"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-responsive
            class="mx-auto title font-weight-light mb-8"
            max-width="720"
          >
            <b>제1조 목적</b>

<br><br>이 개인정보처리방침은 LITOC(이하 "회사"라 합니다)이 제공하는 서비스(이하 "서비스"라 합니다)의 이용에 대한 개인정보보호에 관한 사항을 규정함을 목적으로 합니다.<br><br>

<b>제2조 적용범위</b>

<br><br>이 개인정보처리방침은 회사가 제공하는 모든 서비스에 적용되며, 회사의 서비스를 이용하는 이용자의 개인정보보호에 관한 기본적인 사항을 규정합니다.<br><br>

<b>제3조 개인정보의 수집 및 이용</b>

<br><br>회사는 이용자가 회사의 서비스를 이용하기 위하여 회원가입을 할 때 다음의 정보를 수집합니다.<br><br>

<ul><li>이메일</li></ul><br>
회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.<br><br>

<ul><li>서비스 제공에 관한 계약의 이행</li>
<li>콘텐츠 제공</li>
<li>회원 관리</li></ul>
<br>회사는 원칙적으로 이용자의 개인정보를 제1항에서 명시한 목적을 달성하기 위하여 필요한 범위 내에서만 수집·이용하며, 다음의 경우를 제외하고는 어떠한 경우에도 이용자의 개인정보를 제3자에게 제공하지 않습니다.<br><br>

<ul><li>이용자가 사전에 동의한 경우</li>
<li>법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</li></ul><br>
<b>제4조 개인정보의 보유 및 이용기간</b>

<br><br>회사는 이용자의 개인정보를 회원탈퇴 시까지 보유·이용하며, 이용자의 개인정보가 더 이상 필요하지 않게 되었을 때에는 지체 없이 파기합니다.<br><br>

<b>제5조 개인정보의 파기절차 및 방법</b>

<br><br>회사는 이용자의 개인정보를 파기할 때 다음과 같은 방법으로 파기합니다.<br><br>

<ul><li>종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각합니다.</li>
<li>전자적 파일 형태의 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.</li></ul><br>
<b>제6조 이용자의 권리 및 행사방법</b>

<br><br>이용자는 개인정보주체로서 다음과 같은 권리를 행사할 수 있습니다.<br><br>

<ul><li>개인정보의 열람, 정정, 삭제, 처리정지 요구</li>
<li>개인정보의 항의·불만처리</li></ul><br>
이용자는 개인정보의 열람, 정정, 삭제, 처리정지 요구를 할 때는 본인임을 확인할 수 있는 신분증과 소명자료를 제출하여야 합니다.<br><br>

회사는 이용자의 요청에 대하여 정당한 사유가 없는 한 지체 없이 처리합니다.<br><br>

<b>제7조 개인정보의 안전성 확보조치</b>

<br><br>회사는 이용자의 개인정보를 안전하게 처리하기 위하여 다음과 같은 안전성 확보조치를 취하고 있습니다.<br><br>

<ul><li>관리적 안전성 확보조치: 내부관리계획의 수립 및 시행, 정기적 직원 교육 등</li>
<li>물리적 안전성 확보조치: 전산실 등의 접근통제, 침입차단시스템 설치 등</li>
<li>기술적 안전성 확보조치: 개인정보처리시스템의 개발·운영·보안 등에 관한 내부관리계획의 수립 및 시행, 개인정보처리시스템에 대한 접근통제, 침입탐지시스템 설치 등</li></ul><br>
<b>제8조 개인정보 보호책임자</b>

<br><br>회사는 개인정보 처리에 관한 업무를 총괄하는 부서를 다음과 같이 지정하고 있습니다.<br><br>

<ul><li><b>부서명: 개인정보보호책임자</b></li>
<li><b>담당자: 이민규</b></li>
<li><b>연락처: 070-4038-9634</b></li></ul>
<br>이용자는 개인정보침해에 대한 신고나 상담이 필요할 경우, 아래의 기관에 문의할 수 있습니다.<br><br>

<ul><li>개인정보보호위원회 : 118</li>
<li>정보통신망 이용촉진 및 정보보호에 관한 법률에 의한 개인정보분쟁조정위원회 : 1336</li>
<li>대검찰청 사이버범죄수사단 : 02-3480-3573</li>
<li>경찰청 사이버안전국 : 182</li></ul><br>
<b>제9조 시행일</b>

<br><br>이 개인정보처리방침은 2023년 12월 8일부터 시행합니다.<br><br>
          </v-responsive>
        </v-container>
        <div class="py-12"></div>
      </section>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    models: [
      {
        title: '6-axis robot arms in action for testing and demonstration purposes.',
        src: require('@/assets/won_1.png')
      },
      {
        title: 'Hands-on technical training on 6-axis robot arm software and hardware handling and trouble-shooting.',
        src: require('@/assets/won_2.png')
      },
      {
        title: 'Classroom training conducted in training facility.',
        src: require('@/assets/won_3.png')
      },
      {
        title: 'AGV as part of Smart Factory Solution Module in Demo/Training Facility.',
        src: require('@/assets/won_4.png')
      },
      {
        title: 'Calibration & Testing of Smart Warehouse and Retrieval Systems Solutions',
        src: require('@/assets/won_5.png')
      },
      {
        title: 'Integration of Robotic Tools for Project Design and Management',
        src: require('@/assets/won_6.png')
      },
      {
        title: 'Software simulation and Project Design Management Modules',
        src: require('@/assets/won_7.png')
      },
      {
        title: 'Multi-purpose AR Training in training facility.',
        src: require('@/assets/won_8.png')
      },
      {
        title: 'Multi-purpose AR Training in training facility.',
        src: require('@/assets/won_9.png')
      },
      {
        title: 'Multi-purpose AR Training in training facility.',
        src: require('@/assets/won_10.png')
      }
    ]
  })
}
</script>
